import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { withRouter } from '@piconetworks/router-adapter'

import Account from 'common/modules/account'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import { getNavigateBackButton } from 'common/pkgs/WizardNavigation'

import EnterEmail from './EnterEmail'

const InjectedEnterEmail = ({ router }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(Account.creators.setLoginEmail())
    }, [dispatch])

    const wizardTypes = useSelector((state) => Wizard.selectors.wizardTypes(state))
    const popupId = useSelector((state) => Wizard.selectors.thisWizardPopupId({ state, router }))
    const parentWizardPayload = useSelector((state) => Wizard.selectors.parentWizardPayload({
        state,
        router,
    }))
    const { optionId, customPrice, wizardName: parentWizardName } = parentWizardPayload
    const isGift = parentWizardName?.includes('GiftWizard')
    const isRegistration = parentWizardName?.includes('RegistrationWizard')
    const resumeCheckout = !!parentWizardName && !isRegistration

    const checkoutSelection = resumeCheckout && {
        pico_popup_id: popupId,
        pico_option_id: optionId,
        pico_custom_price: customPrice,
        pico_is_gift: isGift,
    }

    const popup = useSelector((state) => Loader.selectors.popupGetPopupById(state, popupId))

    /*
     * if we are in the checkout_wizard,
     * and we want to give a gift
     * going back shouldn't take us back to the giftwizard
     * we can check for this by identifying the presence of both gift and checkout wizards
     */
    const checkoutWizardExists = useSelector((state) => (
        Wizard.selectors.getWizard({ state, type: 'CheckoutWizard' })
    ))

    const backButton = getNavigateBackButton({
        wizardTypes,
        popupId,
        router,
        ...(checkoutWizardExists && { wizardName: 'CheckoutWizard' }),
    })

    const loginEmail = useSelector(Account.selectors.loginEmail)

    const signupEmail = useSelector((state) => Wizard.selectors.thisWizardSignupEmail({
        state,
        router,
    }))

    const { welcomeBack } = useSelector((state) => Wizard.selectors.thisWizardPayload({
        state,
        router,
    }))

    return (
        <EnterEmail
            popupId={popupId}
            checkoutSelection={checkoutSelection}
            onBackButtonClick={backButton.onClick}
            renderBackButton={backButton.shouldRender}
            popup={popup}
            signupEmail={signupEmail}
            welcomeBack={welcomeBack}
            router={router}
            loginEmail={loginEmail}
        />
    )
}

InjectedEnterEmail.propTypes = {
    router: PropTypes.any.isRequired,
}

export default withRouter(InjectedEnterEmail)
